export default function FAQSection() {
  const items = [
    {
      q: '天堂影视真的完全免费吗？',
      a: '是的，天堂影视所有电影资源均免费在线观看，无需注册登录，无需付费会员，打开就能看。我们通过广告合作维持运营，但承诺绝不插入片头广告、贴片广告或弹窗广告打扰观影体验。',
    },
    {
      q: '画质如何？会卡顿缓冲吗？',
      a: '天堂影视支持 1080P 至 4K 高清蓝光画质，采用全球 CDN 加速分发和自适应码率技术，根据你的网络情况自动匹配最佳画质，确保播放流畅不卡顿，平均首次加载时间不到 2 秒。',
    },
    {
      q: '片库更新频率是怎样的？',
      a: '我们的内容团队每日更新片库，最新院线下映影片通常在 48 小时内上线，经典高分电影持续补充入库。同时推出每日荐片、每周专题等精选栏目，帮助影迷发现好电影。',
    },
    {
      q: '手机和平板能看吗？',
      a: '完全可以！天堂影视完美适配手机、平板和电脑，无需下载任何 APP，打开浏览器访问即可。支持横竖屏自动切换，提供夜间模式保护视力，流量情况下自动优化播放质量节省流量。',
    },
  ];

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          新人观影必读，快速了解天堂影视
        </p>
        <div className="mt-8 grid gap-3">
          {items.map((item, i) => (
            <details
              key={i}
              className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200/30 transition-colors">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-7 h-7 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-600"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}